import { render, staticRenderFns } from "./OrganizMarketDataDetail.vue?vue&type=template&id=22e3337c&scoped=true&"
import script from "./OrganizMarketDataDetail.vue?vue&type=script&lang=js&"
export * from "./OrganizMarketDataDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e3337c",
  null
  
)

export default component.exports